export default __webpack_public_path__ + "static/media/eye-open.070f49cc.svg";